var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-stepper', _vm._b({
    staticClass: "d-flex flex-column",
    attrs: {
      "elevation": "0"
    }
  }, 'v-stepper', Object.assign({}, _vm.$attrs, {
    value: _vm.value
  }), false), [_c('v-stepper-header', _vm._b({
    staticClass: "elevation-0 border mb-40 mb-lg-60",
    staticStyle: {
      "flex": "0 0 auto"
    }
  }, 'v-stepper-header', _vm.$attrs.headerProps || {}, false), [_vm._l(_vm.steps, function (_ref) {
    var step = _ref.step,
      text = _ref.text,
      complete = _ref.complete,
      editable = _ref.editable;
    return [_c('v-stepper-step', _vm._b({
      key: `${step}-step`
    }, 'v-stepper-step', {
      step,
      complete,
      editable
    }, false), [_c('i', {
      class: 'mb-12 mb-lg-20 icon icon-step icon-step--' + step
    }), _c('h5', {
      staticClass: "v-stepper__step__title page-text--lg mb-2"
    }, [_vm._v("STEP " + _vm._s(step))]), _c('p', {
      staticClass: "v-stepper__step__detail page-text--sm"
    }, [_vm._v(_vm._s(text))])])];
  })], 2), _c('v-stepper-items', _vm._b({
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto"
    }
  }, 'v-stepper-items', _vm.$attrs.itemsProps || {}, false), [_vm._l(_vm.steps, function (_ref2) {
    var step = _ref2.step,
      node = _ref2.node;
    return [_c('v-stepper-content', _vm._b({
      key: `${step}-content`
    }, 'v-stepper-content', {
      step
    }, false), [_vm.$slots[step] ? _vm._t(step) : node ? _c('v-node', _vm._b({}, 'v-node', {
      node
    }, false)) : _vm._e()], 2)];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }